const buttonCls = "dibb78tx3j";
const flagCls = "dibfp2l4q4";

export { buttonCls, flagCls };
import "./flag-button.style.linaria.module.css";
//# sourceMappingURL=flag-button.style.js.map
